module.exports = __webpack_public_path__ + "static/media/health.008293fe.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/health.svg
// module id = 281
// module chunks = 0